import { DOMAIN_TOPOLOGY } from '../generated/domainTopology';
import { resolveApiBaseUrl } from '../utils/apiBase';

export const resolvePlatformPrimaryUrl = () => resolveApiBaseUrl();

const resolvePlatformFallbackUrls = () => {
    const defaultMarket = DOMAIN_TOPOLOGY.default_market;
    const markets = Object.entries(DOMAIN_TOPOLOGY.markets)
        .filter(([market]) => market !== defaultMarket)
        .map(([, payload]) => `https://${payload.domains.api}`);
    return markets.length > 0
        ? markets
        : [`https://${DOMAIN_TOPOLOGY.markets[defaultMarket].domains.api}`];
};

export const PLATFORM_CONFIG = {
    // 全球主节点
    get primaryUrl() {
        return resolvePlatformPrimaryUrl();
    },

    // 备用节点 (自动故障转移 - 模拟)
    fallbackUrls: resolvePlatformFallbackUrls(),

    version: 'v1',
    timeout: 30000,
    retryAttempts: 3,
};
